import LineChart from './LineChart.vue'

export default LineChart



// WEBPACK FOOTER //
// ./client/masteradmin/components/LineChart/index.js